module.exports = __webpack_public_path__ + "img/c0df7dd.svg";